module.exports = __webpack_public_path__ + "static/media/seur.aa211692.svg";